<template>
    <div :class="{'module-cropper': true, 'enabled': enabled}">
        <input :id="'file-'+src" type="file" @change="change" accept="image/*">
        <label :for="'file-'+src" ref="filechooser" class="btn btn-choose-image" @click="showCropper">
            <img :src="imgSrc" :id="'image-'+src" >
        </label>
        <div v-show="cropperVisible" class="cropper-modal">
            <span class="cropper-close" @click="reset()"><img src="/images/icon-x.svg"></span>
            <div class="cropper-wrapper" ref="thisCropper">
                <div :class="'block block-cropper active'">
                    <div class="cropper-body">
                        <div :id="'croppie-'+src"></div>
                        <div class="btns">
                            <button @click.prevent="rotate(90)" class="btn-rotate"></button>
                            <span class="btn-camera" @click="chooseFile"></span>
                        </div>
                        <div v-if="btnLoading" class="cropper-saving"><img src="/assets/images/loader-photo.gif"></div>
                    </div>
                    <div class="cropper-footer">
                        <div style="margin:auto">
                            <span :class="btnLoading ? 'btn btn-diap show-loading' : 'btn btn-diap'" @click.stop="upload()">Klaar met bijsnijden</span>
                        </div>
                    </div>
                </div>
                <div class="bg-cropper" @click="reset()" @keyup.esc="reset()"></div>
            </div>
        </div>

    </div>
</template>
<script type='text/babel'>
    import {mapState} from 'vuex'
    // import Croppie from 'croppie'
    // import 'croppie/croppie.css'
    import {TweenMax} from "gsap/all"

    export default {
        props: ['src','enabled'],

        data: function () {
            return {
                croppieElm: false,
                cropped: null,
                saving: false,
                btnLoading: null,
                cropperVisible: false,
                imgSrc: '/assets/images/upload-placeholder.png'
            }
        },
        mounted() {
            this.initCroppie()
            document.body.addEventListener('keyup', e => {
                if (e.keyCode === 27) {
                    this.reset()
                }
            })
        },
        computed: {
            cropperOverlay() {
                return this.$refs.thisCropper
            },

            viewport() {
                if(window.innerWidth < 500){
                    return {width: 300, height: 450, type: 'profile'}
                }
                else {
                    return {width: 350, height: 525, type: 'profile'}
                }
            },
            boundary() {
                if(window.innerWidth < 500){
                    return {width: 320, height:  470}
                }
                else {
                    return {width: 400, height:  575}
                }
            },
        },
        methods: {
            initCroppie() {
                let div = document.getElementById('croppie-' + this.src)
                /** not using vue-cropper but croppie: https://github.com/Foliotek/Croppie/issues/352 **/
                this.croppieElm = new Croppie(div, {
                    boundary: this.boundary,
                    viewport: this.viewport,
                    enableOrientation: true,
                    enableExif: true,
                })
            },
            upload() {
                this.btnLoading = true
                let options = {
                    type: 'base64',
                    format: 'jpeg',
                    size: {width: 1000},
                    circle: false
                }
                this.croppieElm.result(options).then(function (image) {
                    let data = {image: image, src: this.src}
                    axios.post('/uploads/image', data).then((response) => {
                        this.imgSrc = response.data+'?r='+Math.random(100);
                        this.$store.dispatch('setNoofPhotos', this.src)
                        this.reset()
                    })
                }.bind(this))
            },
            change(file) {
                if (!file.target.files[0].name.match(/.(jpg|jpeg|png|gif)$/i)) {
                    return
                }
                this.croppieElm.bind({
                    url: window.URL.createObjectURL(event.target.files[0]),
                    zoom: 0.1
                })
            },
            rotate(rotationAngle) {
                this.croppieElm.rotate(rotationAngle)
            },
            showCropper() {
                if(this.enabled) {
                    this.cropperVisible = true
                    TweenMax.to(this.cropperOverlay, 0.4, {top: 0})
                    document.body.classList.add('show-cropper')
                }
            },
            chooseFile() {
                this.$refs.filechooser.click();
            },
            reset() {
                TweenMax.to(this.cropperOverlay, 0.4, {top: window.innerHeight})
                setTimeout(function () {
                    this.cropperVisible = false
                    document.body.classList.remove('show-cropper')
                }.bind(this), 400)
                this.btnLoading = false
            },
        }
    }
</script>
